export default "__VITE_ASSET__e0909fe2__"